export const theme = {
  background: 'white',
  boxShadow: '0px 0px 12px 4px #f6f6f9',
  border: '1px solid #D3DBF8'
};
